export default "__VITE_ASSET__CZC4G4Wb__"